// Utility script to add subdomain field to existing schools
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../services/firebase";

const generateSubdomain = (name) => {
  return name
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with hyphens
    .replace(/[^a-z0-9-]/g, '')     // Remove special characters
    .replace(/-+/g, '-')            // Replace multiple hyphens with single
    .replace(/^-|-$/g, '');         // Remove leading/trailing hyphens
};

export const updateExistingSchools = async () => {
  try {
    console.log("Updating existing schools with subdomain field...");
    
    const schoolsRef = collection(db, "schools");
    const snapshot = await getDocs(schoolsRef);
    
    const updates = [];
    
    snapshot.forEach((schoolDoc) => {
      const data = schoolDoc.data();
      
      // Only update if subdomain is missing
      if (!data.subdomain) {
        const subdomain = generateSubdomain(data.name);
        console.log(`Adding subdomain "${subdomain}" to school: ${data.name}`);
        
        updates.push(
          updateDoc(doc(db, "schools", schoolDoc.id), {
            subdomain: subdomain,
            portalUrl: `https://portal.iconikschools.com/${subdomain}`
          })
        );
      }
    });
    
    await Promise.all(updates);
    console.log(`Updated ${updates.length} schools with subdomain field`);
    
    return true;
  } catch (error) {
    console.error("Error updating schools:", error);
    return false;
  }
};